export enum OrderListDisplayStatus {
  GENERAL_SUCCESS = 0, // Reserved
  REDEEMED = 2, // UsedOrExpired
  CERTIFICATION_REDEEMED = 5, // Cert
  REVIEWED = 9,
  GENERAL_CANCELLED = 10,
}

export enum OrderDetailDisplayStatus {
  GENERAL_UNREDEEMED = 0,
  CERTIFICATION_UNREDEEMED = 1,
  GENERAL_REDEEMED_OR_EXPIRED = 5,
  CERTIFICATION_REDEEMED_OR_EXPIRED = 6,
  GENERAL_REVIEWED = 10,
  CERTIFICATION_REVIEWED = 11,
  GENERAL_CANCELLED = 19,
}

export enum OrderReviewStatus {
  NOT_REVIEWED,
  REVIEWED,
}

export interface GetOrdersReqParams {
  size?: number
  start?: number
}
